import { createSlice } from "@reduxjs/toolkit";
import { DivisionProps } from "../types";

const initialState: DivisionProps = {
  divisionData: null,
};

const divisionReducer = createSlice({
  name: "division",
  initialState: initialState,
  reducers: {
    fetchDivisionSuccess(state, action) {
      return {
        ...state,
        divisionData: action.payload,
      };
    },
  },
});

export default divisionReducer.reducer;

export const { fetchDivisionSuccess } = divisionReducer.actions;
